import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categories-one',
  templateUrl: './categories-one.component.html',
  styleUrls: ['./categories-one.component.scss']
})
export class CategoriesOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
